/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  AHdeviceTypeEnum,
  ModbusCommandsAttributes,
  SendCommandStringResponse,
} from '..';
import {
  serializeModbusCommandsAttributes,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface SendModbusCommandForAHInput {
  loggerId: string;
  deviceSN: string;
  deviceType: AHdeviceTypeEnum;
  transactionId?: string;
  dataMap: ModbusCommandsAttributes[];
}
const build = (_query: DocumentNode, input: SendModbusCommandForAHInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.loggerId !== undefined ? `$loggerId: String = ${JSON.stringify(input.loggerId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.deviceSN !== undefined ? `$deviceSN: String = ${JSON.stringify(input.deviceSN).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.deviceType !== undefined ? `$deviceType: AHdeviceTypeEnum = ${input.deviceType}, ` : '' ) + ``+
    ( input.transactionId !== undefined ? `$transactionId: String = ${JSON.stringify(input.transactionId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.dataMap !== undefined ? `$dataMap:  [ ModbusCommandsAttributes ]  = ${'[' + input.dataMap.map((item) => serializeModbusCommandsAttributes(item)).join(",") + ']'}` : '' ) + `){
    sendModbusCommandForAH(
      ${ input.loggerId !== undefined ? 'loggerId: $loggerId,' : '' } 
      ${ input.deviceSN !== undefined ? 'deviceSN: $deviceSN,' : '' } 
      ${ input.deviceType !== undefined ? 'deviceType: $deviceType,' : '' } 
      ${ input.transactionId !== undefined ? 'transactionId: $transactionId,' : '' } 
      ${ input.dataMap !== undefined ? 'dataMap: $dataMap,' : '' }
    ){
      ...sendcommandstringresponse
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class SendModbusCommandForAHMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment sendcommandstringresponse on SendCommandStringResponse { ... }
   */
  async execute(_query: DocumentNode, input: SendModbusCommandForAHInput): Promise<apollo.FetchResult< { sendModbusCommandForAH: Partial<SendCommandStringResponse> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ sendModbusCommandForAH: Partial<SendCommandStringResponse> }>({ mutation: build(_query, input) });
  }
}
